<template>
  <v-card>
    <v-card-title>{{this.$t('races.startList')}}</v-card-title>
    <v-card-text>
        <Exporter :headers="headers" :data="this.items" filename="runs.csv" />
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="this.items"
            :sort-by.sync="sorting"
            must-sort hide-default-headers show-select 
            disable-pagination hide-default-footer dense>
        
        <template v-slot:item="{item, select, isSelected}">
          <tr :class="rowClass(item) + ((item.startNumber % 2 == 0 && sorting == 'startNumber') ? '' : 'borderTop ')">
            <td>
              <v-checkbox
                :value="isSelected"
                primary
                hide-details
                @change="select(!isSelected)"
              ></v-checkbox>
            </td>
            <td>
                 <v-menu open-on-click right offset-x>
                  <template v-slot:activator="{ on }">
                  <v-text-field v-on="on"
                    :prefix="item.startNumber+''" 
                    small single-line style="width:60px" hide-details
                    v-model="item.newStartNumber"></v-text-field>
                  </template>
                  <v-list>
                    <v-list-item @click="relocate(item)">
                      <v-list-item-title>
                        <v-icon>save</v-icon> Relocate
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="swap(item)">
                      <v-list-item-title>
                        <v-icon>cached</v-icon> Swap
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
            </td>
            <td>
              <v-icon color="yellow" v-if="tired(item)">warning</v-icon>
              <v-icon color="orange" v-if="restless(item)">warning</v-icon>
              <v-icon color="red" v-if="overlaps(item)">warning</v-icon>
              <router-link :to="'/app/runs/'+item.id" class="font-weight-bold ">
                {{item.application.title}}
              </router-link>  
            </td>
            <td>
              {{item.application.assignedCategory.label}}
            </td>
          </tr>
          <tr :class="rowClass(item) + ((item.startNumber % 2 == 0 && sorting == 'startNumber') ? 'borderBottom' : '')">
            <td></td>
            <td colspan="3" v-if="item.application.applicationCompetitors.length > 1">
              <v-chip v-for="c in item.application.applicationCompetitors" :key="c.id">
                <flag :iso="c.competitor.country" />
                &nbsp; {{c.competitor.firstName}} {{c.competitor.lastName}}
              </v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-btn color="success" @click="assign()">
      {{ $t("races.assignStartNumbers") }}
      </v-btn>
      <v-btn color="error" @click="$refs.removeDialog.show()">
      {{ $t("ctrl.delete") }}
      </v-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn color="yellow" @click="evaluation()">
          {{ $t("races.evaluationSheets") }}
          </v-btn>
        </template>
        <span>Print evaluation sheets for selected runs. Print a single empty sheet in case nothing is selected.</span>
      </v-tooltip>
    </v-card-actions>
    <v-card-actions>
      <v-btn color="info" @click="chooseRed()">{{ $t("races.chooseRed") }}</v-btn>
      <v-btn color="info" @click="chooseBlue()">{{ $t("races.chooseBlue") }}</v-btn>
      <v-btn color="success" @click="print()">Print start list</v-btn>
    </v-card-actions>

    <ConfirmDialog ref="removeDialog" message="races.confirmRunDelete" cancel="ctrl.close" confirm="ctrl.delete" :onConfirm="confirmDelete" />
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardTitle,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
    VCheckbox,
    VDialog,
    VMenu
  } from 'vuetify/lib'
  import fccapi from '../../fccapi'
  import pdfMake from 'pdfmake';
  import fonts from '../../vfs_fonts.js';
  import Exporter from '../Exporter.vue'
  import ConfirmDialog from '../../dialogs/ConfirmDialog'
  pdfMake.vfs = fonts;

  export default {
    name: 'FCCRaceRuns',
    data: function(){
        return {
            items: [],
            selected: [],
            removeDialog: false,
            sorting: "startNumber"
        }
    },
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
      selectedCompetition: function() {
          return this.$store.getters['competitionId'];
      },
      headers: function(){
          return [
              { text: this.$t("runs.startNumber"), value: "startNumber"},
              { text: this.$t("application.title"), value: "application.title"},
              { text: this.$t("application.category"), value: "application.assignedCategory.label"},
          ];
      },
    },
    methods: {
      rowClass: function(item) {
        var cls = "";
        if (item.disqualification) {
          cls += "grey ";
        }
        else {
          cls += (item.startNumber % 2 == 0) ? "red " : "blue ";
        }
        cls += (this.$vuetify.theme.dark) ? "darken-4 " : "lighten-4 ";
        return cls;
      },
        applicationType: function(i) {
            return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
        },
        reload: function(){
            fccapi.get(`races/${this.$route.params.id}/runs`).then(d=>{
                this.items = d.data
            })
        },
        assign: function(){
          fccapi.post(`races/${this.$route.params.id}/assign`).then(d => {
            this.reload();
          })
        },
        print: function(){
          fccapi.get(`races/${this.$route.params.id}/print`).then(d => {
            var docDefinition = d.data;
            console.log(docDefinition);
            pdfMake.tableLayouts = {
              startListStyle: {
                hLineWidth: function (i, node) {
                  if (i === 0 || i === node.table.body.length) {
                    return 0;
                  }
                  if (i === node.table.headerRows) return 2;
                  return i % 2 == 1 ? 1.5 : 0.5;
                },
                vLineWidth: function (i) {
                  return 0;
                },
                hLineColor: function (i) {
                  return i %2 == 1 ? '#020202' : '#AAA';
                },
                paddingLeft: function (i) {
                  return i === 0 ? 0 : 8;
                },
                paddingRight: function (i, node) {
                  return (i === node.table.widths.length - 1) ? 0 : 8;
                },
                fillColor: function(i){
                  if(i == 0) return 'white';
                  return i%2 == 1 ? '#FFD' : '#DFF';
                }
              }
            };
            var filename = "Start list.pdf";
            pdfMake.createPdf(docDefinition).download(filename);
          })
        },
        overlaps: function(item){
          var otherNumber = item.startNumber + 1;
          if (item.startNumber % 2 == 0) otherNumber -= 2;
          return this.overlapWith(item, otherNumber);
        },
        tired: function(item) {
          var start = item.startNumber + (item.startNumber % 2) - 1;
          return this.overlapWith(item, start - 4) ||
            this.overlapWith(item, start - 3) ||
            this.overlapWith(item, start + 4) ||
            this.overlapWith(item, start + 5);
        },
        restless: function(item) {
          var start = item.startNumber + (item.startNumber % 2) - 1
          return this.overlapWith(item, start - 2) ||
            this.overlapWith(item, start - 1) ||
            this.overlapWith(item, start + 2) ||
            this.overlapWith(item, start + 3);
        },
        overlapWith: function(item, otherNumber) {
          var run = this.items.filter(i => i.startNumber == otherNumber)[0];
          if(!run) return false;
          var ac1 = run.application.applicationCompetitors;
          var ac2 = item.application.applicationCompetitors;
          for(var i = 0; i < ac1.length; i++){
            for(var j = 0; j < ac2.length; j++){
              if(ac1[i].competitorId == ac2[j].competitorId) return true;
            }
          }
          return false;
        },
        evaluation: function(){
          var promises = [];
          var organizer = this.$store.getters['competition'].organizer;
          var se = this.selected.sort((a, b) => (a.startNumber > b.startNumber) ? 1 : -1);
          for(var i = 0; i < this.selected.length; i++){
            var s = se[i];
            var p = fccapi.get(`runs/${s.id}/evaluation2`);
            promises.push(p);
          }

          // Print empty evaluation for first
          if (this.selected.length == 0)
          {
            var p = fccapi.get(`runs/${this.items[0].id}/evaluation2/e`);
            promises.push(p);
          }

          Promise.all(promises).then(function (values) {
            var docDefinition;
            for (var i = 0; i < values.length; i++) {
              if (!docDefinition) {
                docDefinition = values[i].data;
              }
              else {
                for (var j = 0; j < values[i].data.content.length; j++) {
                  docDefinition.content.push(values[i].data.content[j]);
                }
              }
            }

            //docDefinition.watermark = { image: testImageDataUrl, width: 200 };//'/images/watermark.png' };
            docDefinition.footer = (currentPage, pageCount, pageSize) => {
              return [
                {
                  //text: "Organizator tekmovanja je\nProstovoljno gasilsko društvo Radovljica, Gorenjska cesta 31, 4240 Radovljica",
                  text: "Competition organizer:\n"+organizer.longName+", "+organizer.address,
                  alignment: 'center',
                  margin: [20, -25, 20, 20]
                }
              ]
            };
            docDefinition.content.splice(-1, 1);
            var filename = values.length + " evaluation sheets.pdf";
            pdfMake.createPdf(docDefinition).download(filename);
          });
        },
        confirmDelete: function(){
          console.log("Deleting runs")
          console.log(this.selected)
          if(this.selected.length == 0) return;
          var last = this.selected[this.selected.length-1].id;

          this.selected.reduce((p, run) => {
            return p.then(() => {
              var promise = fccapi.delete(`runs/${run.id}`);
              if(run.id == last) promise.then(nn => {
                this.reload();
              })
              return promise;
            });
          }, Promise.resolve());


          /*fccapi.delete(`runs/${se.id}`).then(d => {
            this.reload();
          });*/
          this.removeDialog = false;
        },
        chooseRed: function(){
          this.selected = [];
          for(var i = 0; i < this.items.length; i++){
            var it = this.items[i];
            if(it.startNumber % 2 == 0 && !it.disqualification)
              this.selected.push(this.items[i]);
          }
        },
        chooseBlue: function(){
          this.selected = [];
          for(var i = 0; i < this.items.length; i++){
            var it = this.items[i];
            if(it.startNumber % 2 == 1 && !it.disqualification)
              this.selected.push(this.items[i]);
          }
        },
        relocate: function(item){
          console.log(JSON.stringify(item))
          fccapi.post(`runs/${item.id}/relocate/${item.newStartNumber}`).then(d => {
            this.reload();
          })
        },
        swap: function(item){
          console.log(JSON.stringify(item))
          fccapi.post(`runs/${item.id}/swap/${item.newStartNumber}`).then(d => {
            this.reload();
          })
        }
    },
    mounted: function(){
        this.reload();
    },
    watch: {
        selectedCompetition() {
            console.log("changed")
            this.reload();
        }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardTitle,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
        VCheckbox,
        Exporter,
        VDialog,
        VMenu,
        ConfirmDialog
    },    
  }
</script>
<style scoped>
th {
  padding: 2px !important;
}
.borderNone>td{
  border-bottom: 0px solid #777 !important;
  border-top: 0px solid #777 !important;
}
.lighten-4.borderBottom>td{
  border-bottom: 2px solid #555 !important;
}
.lighten-4.borderTop>td{
  border-top: 2px solid #555 !important;
}
.darken-4.borderBottom>td{
  border-bottom: 2px solid #FFF !important;
}
.darken-4.borderTop>td{
  border-top: 2px solid #FFF !important;
}
tr.darken-4 a{
  color: white;
}
tr.lighten-4 a {
  color: black;
}
.v-input {
  margin-top: 0;
  padding-top: 0;
}
</style>